var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('OfficialHeader'),_c('v-content',[_c('router-view')],1),_c('main-footer',{staticClass:"mt-3"}),_c('enterprise-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }